import Award from './Award';
import TurtleOutro from './TurtleOutro';
import ModuleRating from './ModuleRating';

export default [
    Award,
    // ModuleRating,
    // TurtleOutro,
];
